import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

import { PlantModelParameterService } from '@app/services/plant-model-parameter.service';
import { ParameterFormComponent } from '@app/shared/parameter-form/parameter-form.component';
import { ParameterFormRowsComponent } from '@app/shared/parameter-form-rows/parameter-form-rows.component';
import { PreventSubmitOnEnterDirective } from '@app/shared/prevent-submit-on-enter.directive';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-plant-model-parameter-form',
  templateUrl: '../parameter-form/parameter-form.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    PreventSubmitOnEnterDirective,
    ParameterFormRowsComponent,
    NgbTooltip,
    AsyncPipe,
  ],
})
export class PlantModelParameterFormComponent extends ParameterFormComponent {
  protected plantModelParameterService = inject(PlantModelParameterService);

  onApply(values: any) {
    const parsedValues = this.parameterService.parsePlantModelParameterControlValues(values);
    this.plantModelParameterService.requestSetPlantModelParameterValues(parsedValues);

    const control = this.firstControlFrom(values);
    control.markAsPristine();

    super.onApply(values);
  }

  onUnitChange(value: any) {
    Object.entries(value).forEach(([id, unit]: [string, string]) => {
      this.plantModelParameterService.updatePlantModelParameter(id, { unit });
    });

    super.onUnitChange(value);
  }

  onSubmit() {
    if (this.form.pristine) {
      return;
    }

    const values = this.form.value;

    Object.entries(values).forEach(([id]) => {
      if (this.form.controls[id].pristine) {
        delete values[id];
      }
    });

    const parsedValues = this.parameterService.parsePlantModelParameterControlValues(values);
    this.plantModelParameterService.requestSetPlantModelParameterValues(parsedValues);

    this.form.markAsPristine();

    super.onSubmit();
  }
}
